import { CommonModule } from "@angular/common";
import { Component, Input, ViewEncapsulation, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { RequestService } from "../../../../../services/request";

@Component({
    selector: 'mi-send-dialog',
    imports: [CommonModule,
    ],
    templateUrl: './send-dialog.html',
    styleUrl: './send-dialog.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class SendDialogComponent implements OnDestroy {




    @Input() unionReqiestId!: number;

    //#region _isSuccessSend
    public _isSuccessSend: boolean = false;
    get isSuccessSend(): boolean {
        return this._isSuccessSend;
    }
    @Input()
    set isSuccessSend(newValue: boolean) {
        if (newValue !== this._isSuccessSend) {
            this._isSuccessSend = newValue
        }
        this.updateByIsSuccessSend();

    }
    //#endregion

    subscribtion: Subscription = new Subscription()
    sendDialogText: any;
    sendDialogTextPath: string = 'send.error-dialog';


    constructor(private translateService: TranslateService
        , private router: Router
        , private requestService: RequestService) {

    }



    initText() {
        if (this.isSuccessSend) {
            this.sendDialogTextPath = 'send.dialog';
        }
        this.subscribtion.add(this.translateService.stream(this.sendDialogTextPath).subscribe(translation => {
            this.sendDialogText = translation;
        }));
    }


    navigation() {
        this.requestService.clearRequestStore();
        this.router.navigate(['']);
    }

    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }

    getDialogText() {
        let dialogtext = '';
        dialogtext = this.sendDialogText?.text;
        if (this.isSuccessSend) {
            dialogtext += ' ' + this.unionReqiestId;
        }
        return dialogtext;
    }

    getSrcImg() {
        const successPath = 'assets/images/components/app/attahments/send.svg';
        const errorPath = 'assets/images/shared/warning.svg';
        return this.isSuccessSend ? successPath : errorPath;
    }

    updateByIsSuccessSend() {
        this.initText();

    }
}